$(document).on('turbo:load', function() {
  $('.tabs').on('click', 'li', function() {
    const tabId = $(this).attr('data-tab');

    $('.tabs li a').removeClass('active');
    $('.tab-pane').removeClass('current');

    $(this).find('.nav-link').addClass('active');
    $("#"+tabId).addClass('current');
  });
});
